// extracted by css-extract-rspack-plugin
export default {"blankslate":"AgentsBlankslate-module__blankslate__i_po2"};